import { analytics } from 'utils/analytics';

export const onSnackClickAnalyticsEvent = (elementText: 'Изменить' | 'Всё верно') =>
  analytics.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'header',
    elementName: 'regionSnackbar',
    elementText,
  });
